module.exports = __webpack_public_path__ + "static/media/G1-37-Hillare-Philemon-cod78.d4bfa8a7.png";